import React from 'react';
import VendorProfileCard from '../components/VendorProfileCard';

const VendorShowcase: React.FC = () => {
  const vendors = [
    {
      name: "EverGreen Lawn Care",
      services: ["Lawn Care", "Irrigation", "HOA Preferred"],
      rating: 4.9,
      reviews: 18,
      verified: true,
      logo: "https://via.placeholder.com/80/22c55e/ffffff?text=EG",
      description: "Professional landscaping and lawn maintenance services"
    },
    {
      name: "ClearView Roofing",
      services: ["Roof Repairs", "Gutter Cleaning"],
      rating: 4.7,
      reviews: 12,
      verified: false,
      logo: "https://via.placeholder.com/80/3b82f6/ffffff?text=CV",
      description: "Expert roofing solutions for residential properties"
    },
    {
      name: "AquaFlow Plumbing",
      services: ["Plumbing", "Emergency Repairs", "Insured"],
      rating: 4.8,
      reviews: 24,
      verified: true,
      logo: "https://via.placeholder.com/80/06b6d4/ffffff?text=AF",
      description: "Plumbing services for residential properties"
    },
    {
      name: "PowerTech Electrical",
      services: ["Electrical Work", "Smart Home", "Licensed"],
      rating: 4.6,
      reviews: 15,
      verified: true,
      logo: "https://via.placeholder.com/80/f59e0b/ffffff?text=PT",
      description: "Modern electrical solutions and smart home installations"
    },
    {
      name: "CleanSlate Pressure Washing",
      services: ["Pressure Washing", "Deck Cleaning", "Eco-Friendly"],
      rating: 4.5,
      reviews: 9,
      verified: false,
      logo: "https://via.placeholder.com/80/8b5cf6/ffffff?text=CS",
      description: "Environmentally friendly exterior cleaning services"
    },
    {
      name: "SecureGuard Security",
      services: ["Security Systems", "Monitoring", "HOA Preferred"],
      rating: 4.9,
      reviews: 31,
      verified: true,
      logo: "https://via.placeholder.com/80/ef4444/ffffff?text=SG",
      description: "Advanced security solutions for residential communities"
    }
  ];

  const handleRequestQuote = (vendor: any) => {
    const message = `
Vendor listing

Vendor: ${vendor.name}
Services: ${vendor.services.join(', ')}
Rating: ${vendor.rating} ⭐ (${vendor.reviews} reviews)
${vendor.verified ? '✅ Verified Vendor' : ''}

Use the contact details in the vendor's listing to request a quote. BlockBoard does not broker
vendor relationships or guarantee vendor availability, pricing, or work.
    `.trim();
    
    alert(message);
  };

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center animate-fade-in">
        <h1 className="text-4xl font-bold text-white mb-4">
          Vendor Directory
        </h1>
        <p className="text-xl text-white/60 max-w-2xl mx-auto">
          Browse vendor listings shared by your community. Ratings and verification labels come from
          the community's records; BlockBoard does not independently vet vendors.
        </p>
      </div>

      {/* Vendor Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {vendors.map((vendor, index) => (
          <div 
            key={vendor.name} 
            className="animate-fade-in"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <VendorProfileCard 
              vendor={vendor} 
              onRequestQuote={handleRequestQuote}
            />
          </div>
        ))}
      </div>

      <div className="floating-card text-center animate-fade-in">
        <p className="text-white/60">
          Vendor listings, ratings, and verification status are managed by each community.
        </p>
      </div>
    </div>
  );
};

export default VendorShowcase; 